import React from 'react'
import Todo from './Todo'

export default function App() {
  return (
    <div>
      <Todo />
    </div>
  )
}
